// DEPENDENCIES //
import React, { useState, useEffect } from "react";

// IMAGES //
import allo from "../../assets/slideshow_allo_01.png";
import brandon from "../../assets/slideshow_brandon_01.png";
import chinatown from "../../assets/slideshow_chinatown_01.png";

import slideshow_cp_01 from "../../assets/slideshow_cp_01.png";
import slideshow_cp_02 from "../../assets/slideshow_cp_02.png";

import slideshow_ml_01 from "../../assets/slideshow_ml_01.png";
import slideshow_ml_02 from "../../assets/slideshow_ml_02.png";
import slideshow_ml_03 from "../../assets/slideshow_ml_03.png";
import slideshow_ml_04 from "../../assets/slideshow_ml_04.png";
import slideshow_ml_05 from "../../assets/slideshow_ml_05.png";
import slideshow_ml_06 from "../../assets/slideshow_ml_06.png";
import slideshow_ml_07 from "../../assets/slideshow_ml_07.png";
import slideshow_ml_08 from "../../assets/slideshow_ml_08.png";
import slideshow_ml_09 from "../../assets/slideshow_ml_09.png";
// import slideshow_ml_10 from "../../assets/slideshow_ml_10.png";

import mrsCleo01 from "../../assets/slideshow_mrs_cleo_01.png";
// import mrsCleo02 from "../../assets/slideshow_mrs_cleo_02.png";
import mrsCleo03 from "../../assets/slideshow_mrs_cleo_03.png";

import nycDate from "../../assets/slideshow_nyc_date_01.png";
// import pirata from "../../assets/slideshow_pirata_01.png";

import slideshow_pvg_01 from "../../assets/slideshow_pvg_01.png";
// import slideshow_pvg_02 from "../../assets/slideshow_pvg_02.png";
import slideshow_pvg_03 from "../../assets/slideshow_pvg_03.png";
import slideshow_pvg_04 from "../../assets/slideshow_pvg_04.png";
import slideshow_pvg_05 from "../../assets/slideshow_pvg_05.png";
import slideshow_pvg_06 from "../../assets/slideshow_pvg_06.png";
import slideshow_pvg_07 from "../../assets/slideshow_pvg_07.png";
import slideshow_pvg_08 from "../../assets/slideshow_pvg_08.png";
import slideshow_pvg_09 from "../../assets/slideshow_pvg_09.jpg";
import slideshow_pvg_10 from "../../assets/slideshow_pvg_10.png";
import slideshow_pvg_11 from "../../assets/slideshow_pvg_11.png";

import ridingHood from "../../assets/slideshow_riding_hood_01.png";
import scooterGang from "../../assets/slideshow_scooter_01.png";

// import slideshow_tjs_01 from "../../assets/slideshow_tjs_01.png";
// import slideshow_tjs_02 from "../../assets/slideshow_tjs_02.png";
// import slideshow_tjs_03 from "../../assets/slideshow_tjs_03.png";
// import slideshow_tjs_04 from "../../assets/slideshow_tjs_04.png";
// import slideshow_tjs_05 from "../../assets/slideshow_tjs_05.png";
// import slideshow_tjs_06 from "../../assets/slideshow_tjs_06.png";
// import slideshow_tjs_07 from "../../assets/slideshow_tjs_07.jpg";

// STYLES //
import "./slideshowWide.css"

// HELPER FUNCTIONS //
function shuffle(array) {
  const copy = [...array];

  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));

    [copy[i], copy[j]] = [copy[j], copy[i]];
  }

  return copy;
}

function Slideshow() {
  const [images] = useState(() =>
    shuffle([
      allo,
      brandon,
      chinatown,

      slideshow_cp_01,
      slideshow_cp_02,
      slideshow_ml_01,
      slideshow_ml_02,
      slideshow_ml_03,
      slideshow_ml_04,
      slideshow_ml_05,
      slideshow_ml_06,
      slideshow_ml_07,
      slideshow_ml_08,
      slideshow_ml_09,
      // slideshow_ml_10,

      mrsCleo01,
      // mrsCleo02,
      mrsCleo03,

      nycDate,
      // pirata,

      slideshow_pvg_01,
      // slideshow_pvg_02,
      slideshow_pvg_03,
      slideshow_pvg_04,
      slideshow_pvg_05,
      slideshow_pvg_06,
      slideshow_pvg_07,
      slideshow_pvg_08,
      slideshow_pvg_09,
      slideshow_pvg_10,
      slideshow_pvg_11,

      ridingHood,
      scooterGang,

      // slideshow_tjs_01,
      // slideshow_tjs_02,
      // slideshow_tjs_03,
      // slideshow_tjs_04,
      // slideshow_tjs_05,
      // slideshow_tjs_06,
      // slideshow_tjs_07,
    ])
  );

  // const [currentSlide, setCurrentSlide] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [previousSlide, setPreviousSlide] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setPreviousSlide(currentSlide);
      setCurrentSlide((currentSlide + 1) % images.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [currentSlide, images.length]);

  return (
    <div className="slideshow-container">
      <div className="slideshow">
        {previousSlide !== null && (
          <img
            className="slideshow-image previous-slide"
            src={images[previousSlide]}
            alt=""
          />
        )}

        <img
          key={currentSlide}
          className="slideshow-image current-slide"
          src={images[currentSlide]}
          alt={`Slide ${currentSlide + 1}`}
        />
      </div>
    </div>
  );
}

export default Slideshow;

